import { DateTimeFormatOptions, DateTimeFormats } from 'vue-i18n'

export type DateTimeFormatNames = 'short' | 'timeOnly' | 'dateOnly' | 'shortDateOnly' | 'shortNoYear' | 'fullDateWithWeekday'

type GMSDateTimeFormat = { [K in DateTimeFormatNames]: DateTimeFormatOptions }

const en: GMSDateTimeFormat = {
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  timeOnly: {
    hour: 'numeric',
    minute: 'numeric',
  },
  dateOnly: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
  shortDateOnly: {
    month: 'short',
    day: 'numeric',
  },
  shortNoYear: {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  fullDateWithWeekday: {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }
}

const de: GMSDateTimeFormat = {
  short: {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  timeOnly: {
    hour: 'numeric',
    minute: 'numeric',
  },
  dateOnly: {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  },
  shortDateOnly: {
    month: 'numeric',
    day: 'numeric',
  },
  shortNoYear: {
    day: 'numeric',
    month: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  fullDateWithWeekday: {
    weekday: 'long',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
}

const it: GMSDateTimeFormat = {
  short: {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  timeOnly: {
    hour: 'numeric',
    minute: 'numeric',
  },
  dateOnly: {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  },
  shortDateOnly: {
    month: 'numeric',
    day: 'numeric',
  },
  shortNoYear: {
    day: 'numeric',
    month: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  fullDateWithWeekday: {
    weekday: 'long',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
}

const fr: GMSDateTimeFormat = {
  short: {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  timeOnly: {
    hour: 'numeric',
    minute: 'numeric',
  },
  dateOnly: {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  },
  shortDateOnly: {
    month: 'numeric',
    day: 'numeric',
  },
  shortNoYear: {
    day: 'numeric',
    month: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  fullDateWithWeekday: {
    weekday: 'long',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
}

export const defaultDateTimeFormats: DateTimeFormats = {
  en,
  de,
  it,
  fr,
}